module.exports = __webpack_public_path__ + "static/media/figureman-3.2c45c03b.png";